import { create } from 'zustand';

/**
 * uiStore — estado de UI que DOIS módulos diferentes precisam enxergar.
 *
 * `processoParaAbrir` é o único caso legítimo hoje: o CRM manda abrir um
 * processo e o Jurídico recebe. Dois consumidores reais, agora.
 *
 * `abaConfiguracao` foi removido em 22/09/2026: aba é parâmetro de navegação,
 * e parâmetro de navegação é papel da URL (`/configuracoes/<aba>`), não de um
 * store global. Ver docs/arquitetura/ARQUITETURA-FRONTEND.md (R3).
 *
 * REGRA: estado novo nasce local. Só sobe para cá quando dois módulos
 * diferentes precisarem dele HOJE.
 */
export const useUIStore = create((set) => ({
  processoParaAbrir: null,

  setProcessoParaAbrir: (processo) => set({ processoParaAbrir: processo }),
}));
